import {Injectable} from '@angular/core';
import {MatDialog} from '@angular/material/dialog';

import {EnterpriseInfo} from 'shared/dtos/wizard/enterprise-info';
import {DataStorageService} from 'shared/services/data-storage.service';
import {hasValue} from 'shared/utils';
import {EnterpriseInfoCompletionDialog} from './enterprise-info-completion.dialog';

@Injectable({
  providedIn: 'root'
})
export class EnterpriseInfoCompletionDialogService {
  constructor(
    public readonly storage: DataStorageService,
    public readonly dialog: MatDialog
  ) {}

  async performCompletion() {
    const enterpriseInfo = await this.storage.getEnterpriseInfo();
    if (this.isReadyForPruefbericht(enterpriseInfo)) {
      return enterpriseInfo;
    }
    const result = await this.dialog
      .open(EnterpriseInfoCompletionDialog, {
        data: enterpriseInfo,
        maxWidth: '50vw',
        disableClose: true
      })
      .afterClosed()
      .toPromise();
    await this.storage.storeEnterpriseInfo(result);
    return result;
  }

  isReadyForPruefbericht(data: EnterpriseInfo): data is EnterpriseInfo {
    return (
      hasValue(data.firma) && hasValue(data.uid) && hasValue(data.fachperson)
    );
  }
}
